import { AxiosResponse } from "axios";
import axiosApiInstance from "src/api/axiosInstance.api";
import { IApiResponse } from "src/shared/models/IApiResponse";
import { IChart } from "../../shared/models/IDashboards.models";

export interface IChartSingleApiResponse extends IApiResponse {
  data: IChart;
}

export interface IChartListApiResponse extends IApiResponse {
  data: IChart[];
}

const responseBody = (response: AxiosResponse) => response.data;

const requests = {
  getParams: (url: string, body: {}) =>
    axiosApiInstance.put(url, body).then(responseBody),
};

const IDashboardAPIService = {
  getPurchaseSection: (params?: any): Promise<IChartSingleApiResponse> =>
    requests.getParams("/dashboards/purchaseSection", params),
  getInventorySection: (params?: any): Promise<IChartSingleApiResponse> =>
    requests.getParams("/dashboards/inventorySection", params),
  getAccountSection: (params?: any): Promise<IChartSingleApiResponse> =>
    requests.getParams("/dashboards/accountSection", params),
};

export { IDashboardAPIService };
